import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import { Classes, Dialog, H4, Intent, Spinner, Text } from '@blueprintjs/core';
import { observer } from 'mobx-react';
import TranslatedMessage from '../common/translation/TranslatedMessage';
import styled from '@emotion/styled';

const SpinnerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const ErrorContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  color: red;
  flex-direction: column;
`;

interface PlannerFileLoadingModalProps extends WithTranslateProps {
  fileIsLoading: boolean;
  modalOpened: boolean;
  errors: string[];
  onClosed: () => void;
}

//TODO remove this and replace usage by FileLoadingModal
@observer
class PlannerFileLoadingModal extends React.Component<PlannerFileLoadingModalProps> {
  render() {
    const { fileIsLoading, modalOpened, errors, onClosed } = this.props;

    return (
      <Dialog
        isOpen={modalOpened}
        onClose={onClosed}
        title={<TranslatedMessage id={TLCode.PLANNER_FILE_LOADING_MODAL_TITLE} />}
        canOutsideClickClose={false}
      >
        {fileIsLoading ? (
          <SpinnerContainer>
            <Spinner intent={Intent.PRIMARY} size={Spinner.SIZE_STANDARD} />
          </SpinnerContainer>
        ) : (
          <div className={Classes.DIALOG_BODY}>
            {errors.length === 0 && <TranslatedMessage id={TLCode.PLANNER_FILE_SUCCESSFULLY_IMPORT} />}
            {errors.length !== 0 && (
              <>
                <H4>
                  <TranslatedMessage id={TLCode.PLANNER_ERROR_MESSAGE} />
                </H4>
                <ErrorContainer>
                  {errors.map((test: string, index) => {
                    return <Text key={index}>{test}</Text>;
                  })}
                </ErrorContainer>
              </>
            )}
          </div>
        )}
      </Dialog>
    );
  }
}

export default withTranslate(PlannerFileLoadingModal);
